import * as Yup from 'yup';

export const validate = Yup.object().shape({
    titulo: Yup.string().required('Campo Obligatorio'),
    descripcionCorta: Yup.string().required('Campo Obligatorio'),
    descripcion: Yup.string().required('Campo Obligatorio'),
    imagen: Yup.object({}).required('Campo Obligatorio').nullable(),
    destacado: Yup.boolean().required('Campo Obligatorio'),
});
    